<div class="has-background-link">
    <div class="container is-fullhd has-text-centered pt-3 pb-2 pl-1 pr-1">
        <p class="is-size-7 has-text-white">
            Dúvidas? Sugestões? <span class="has-text-weight-bold">suporte@perpetue.me</span>
            <br> © {{currentYear}} perpetue.me uma empresa Jano Serviços. 
            <br> CNPJ 55.591.047/0001-69
            <br> Todos os direitos reservados.
        </p>
        <p class="is-size-7">
            <span class="mr-6"><a class="has-text-white" href="https://perpetue.me/politica-de-privacidade/" target="_blank">Política de privacidade</a></span>  <span><a class="has-text-white" href="https://perpetue.me/termos-de-uso/" target="_blank">Termos de uso</a></span>
        </p>
    </div>
</div>